export const mods = {
  view: "view",
  edit: "edit",
}